import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import TodayReservations from './components/TodayReservations';

const { Cell } = ResponsiveGrid;

const CarServiceToday = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="今日叫車預約"
        breadcrumbs={[
          {
            name: '叫車服務管理',
          },
          {
            name: '今日叫車預約',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <TodayReservations />
    </Cell>
  </ResponsiveGrid>
);

export default CarServiceToday;
